export default function collapse() {
    if ($('.c-collapse').length > 0) {

        const $collapse = {
            item: '.c-collapse__item',
            btn: $('.c-collapse__item--btn'),
            content: '.c-collapse__item--content',
            active_class: 'js-isActive'
        }

        $collapse.btn.click(function () {

            const $container = $(this).closest($collapse.item);
            const $close_btn = $(this).find('svg');

            $container.each(function () {
                if (!$(this).hasClass('js-isActive')) {
                    $('.c-collapse__item').removeClass('js-isActive');
                    $('.c-collapse__item svg').removeClass('js-isActive');
                    $('.c-collapse__item--content').slideUp();
                    TweenMax.to($('.c-collapse__item svg'), .3, {rotation: 0, ease: Power2.easeInOut});
                    $collapse.btn.removeClass($collapse.active_class);
                }
            });

            if (!$container.hasClass($collapse.active_class)) {
                $container.addClass($collapse.active_class);
                $(this).next($collapse.content).slideDown();
                $(this).find('svg').addClass($collapse.active_class);
                TweenMax.to($close_btn, .3, {rotation: 45, ease: Power2.easeInOut});
            } else {
                $container.removeClass($collapse.active_class);
                $(this).next($collapse.content).slideUp();
                $(this).find('svg').removeClass($collapse.active_class);
                TweenMax.to($close_btn, .3, {rotation: 0, ease: Power2.easeInOut});
            }
        })
    }
}

collapse();
